import type { NodeLabelDrawingFunction } from 'sigma/rendering';
import { EdgeAttributes, NodeAttributes } from './graphTypes';
import {
  CONNECTOR_RING_COLOR,
  CONNECTOR_RING_DIMMED_COLOR,
  DIMMED_NODE_COLOR,
  LABEL_BACKGROUND_COLOR,
  LABEL_TEXT_COLOR,
} from './graphColors';

export const createDrawNodeLabel = (showKeyConnectors: boolean): NodeLabelDrawingFunction<NodeAttributes, EdgeAttributes> => (context, data, settings) => {
  if (showKeyConnectors) {
    if (data.isKeyConnector) {
      context.strokeStyle = data.color === DIMMED_NODE_COLOR ? CONNECTOR_RING_DIMMED_COLOR : CONNECTOR_RING_COLOR;
      context.lineWidth = 1;
      context.beginPath();
      context.arc(data.x, data.y, data.size + 3, 0, Math.PI * 2);
      context.stroke();
    }
  }

  if (!data.label) return;

  const size = settings.labelSize;
  const font = settings.labelFont;
  const weight = settings.labelWeight;
  context.font = `${weight} ${size}px ${font}`;

  const paddingX = 4;
  const paddingY = 2;
  const textWidth = context.measureText(data.label).width;
  const boxX = data.x + data.size + 4;
  const boxY = data.y - size / 2 - paddingY;
  const boxWidth = textWidth + paddingX * 2;
  const boxHeight = size + paddingY * 2;
  const radius = Math.min(boxHeight / 2, boxWidth / 2, 6);

  context.fillStyle = LABEL_BACKGROUND_COLOR;
  context.beginPath();
  context.moveTo(boxX + radius, boxY);
  context.arcTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + boxHeight, radius);
  context.arcTo(boxX + boxWidth, boxY + boxHeight, boxX, boxY + boxHeight, radius);
  context.arcTo(boxX, boxY + boxHeight, boxX, boxY, radius);
  context.arcTo(boxX, boxY, boxX + boxWidth, boxY, radius);
  context.closePath();
  context.fill();

  context.fillStyle = LABEL_TEXT_COLOR;
  context.fillText(data.label, boxX + paddingX, data.y + size / 3);
};

